export default __webpack_public_path__ + "static/media/AuditWorksheet.a6092cf8.png";